import {Component} from "react";

class SidebarFooter extends Component {

    render() {
        return null;
    }
}

export default SidebarFooter;



// WEBPACK FOOTER //
// ./src/components/SidebarFooter/SidebarFooter.js